<div fxLayout="column" class="neq-dialog-result-settings">
  <h1>{{ 'label.user.rawmaterials.results.settings.title' | translate }}</h1>
  <span>{{ 'label.user.rawmaterials.results.settings.description' | translate }}</span>

  <div class="neq-action-button" fxLayout="column" fxLayoutAlign="end end">
    <button pButton
      (click)="addRow()"
      class="neq-primeng-button primeng-flat"
      type="button"
      [matTooltip]="'label.user.rawmaterials.results.settings.add' | translate"
    >
      <neq-icon svgIcon="plus"></neq-icon>
    </button>
  </div>

  <ng-container *ngIf="tableData && tableData.results">
    <p-table [columns]="cols" [value]="tableData.results"
             styleClass="neq-primeng-table neq-primeng-table-header-left neq-primeng-table-no-min-height" fxFlex>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">
            {{ 'label.common.column' | translate }}
          </th>
          <ng-container *ngFor="let col of columns">
            <th *ngIf="col.field !== 'matrix'">
              {{col.header | translate}}
            </th>

            <ng-container *ngIf="col.field === 'matrix'">
              <th *ngIf="hasSeveralMatrices()">
                {{col.header | translate}}
              </th>
            </ng-container>
          </ng-container>
          <th>
            Actions
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-index="rowIndex" let-columns="columns">
        <tr>
          <td>
            {{ index + 1 }}
          </td>

          <ng-container *ngFor="let col of columns">
            <td *ngIf="col.field === 'rawMaterial'">
              <div>
                <neq-select-autocomplete [dataSource]="rawMaterialsDatasource"
                                         [defaultLabel]="col.header | translate" bindLabel="customLabel"
                                         #rawMaterialSelectAutocomplete (change)="selectedRawMaterialOrSampleChanged(rowData)"
                                         fxFlex="grow" [(ngModel)]="rowData.rawMaterialOrSample"></neq-select-autocomplete>
                <neq-icon class="action" fxFlexAlign="end" svgIcon="recherche" (click)="goRmAdvancedSearch(index)" (keyDown)="goRmAdvancedSearch(index)"></neq-icon>
              </div>
            </td>
            <td *ngIf="col.field === 'sample'">
              <div>
                <neq-select-autocomplete [dataSource]="samplesDatasource"
                                         [defaultLabel]="col.header | translate" bindLabel="customLabel"
                                         (change)="selectedRawMaterialOrSampleChanged(rowData)"
                                         fxFlex="grow" [(ngModel)]="rowData.rawMaterialOrSample"></neq-select-autocomplete>
                <neq-icon class="action" fxFlexAlign="end" svgIcon="recherche" (click)="goSampleAdvancedSearch(index)" (keyDown)="goSampleAdvancedSearch(index)"></neq-icon>
              </div>
            </td>
            <td *ngIf="col.field === 'matrix' && hasSeveralMatrices()">
              <div>
                <neq-select-autocomplete [dataSource]="matricesDatasource"
                                         [defaultLabel]="col.header | translate" bindLabel="label"
                                         #matrixSelectAutocomplete [clearable]="false"
                                         fxFlex="grow" [(ngModel)]="rowData[col.field]"></neq-select-autocomplete>
              </div>
            </td>

            <td *ngIf="col.field === 'valueType'">
              <div>
                <mat-select fxFlex="grow"
                            placeholder="{{col.header | translate}}" [(ngModel)]="rowData[col.field]"
                            [disabled]="isNotCurrentRawMatOrSample(rowData)">
                  <mat-option *ngFor="let type of valueTypes" [value]="type">
                    {{type | translate}}
                  </mat-option>
                </mat-select>
              </div>
            </td>
          </ng-container>

          <td>
            <div fxLayout="row" fxLayoutGap="0.357rem">
              <neq-icon class="action" fxFlexAlign="end" svgIcon="corbeille" (click)="delete(rowData)" (keyDown)="delete(rowData)"
                        [matTooltip]="'label.user.rawmaterials.results.delete' | translate"></neq-icon>
              <neq-icon *ngIf="!first(index)" class="action" fxFlexAlign="end" svgIcon="chevron-haut" (click)="sortUp(index)" (keyDown)="sortUp(index)"
                        [matTooltip]="'label.common.reorder' | translate"></neq-icon>
              <neq-icon *ngIf="!last(index)" class="action" fxFlexAlign="end" svgIcon="chevron-bas" (click)="sortDown(index)" (keyDown)="sortDown(index)"
                        [matTooltip]="'label.common.reorder' | translate"></neq-icon>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>

  <form [formGroup]="form" (ngSubmit)="continue()" fxLayout="column" fxFlex="1 0 auto">
    <div fxLayout="row" fxFlex="1 1 auto" class="neq-page-wrapper">
      <div class="neq-container" fxLayout="column" fxFlex>
        <mat-checkbox formControlName="resultShowUnit" class="mat-form-field">
          {{'label.user.preferences.result-show-unit' | translate }}
        </mat-checkbox>

        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.714rem">
          <mat-form-field fxFlex="30">
            <input select-all [placeholder]="'label.user.preferences.result-tolerance-percent' | translate" formControlName="code" matInput formControlName="resultTolerancePercent" required>
            <mat-error *ngIf="form.controls.resultTolerancePercent.errors?.required">{{'error.common.field-required'
              | translate}}</mat-error>
            <mat-error *ngIf="form.controls.resultTolerancePercent.errors?.min">
              {{'error.common.numeric.int.between' | translate:{param1: 0, param2: 100} }}
            </mat-error>
            <mat-error *ngIf="form.controls.resultTolerancePercent.errors?.max">
              {{'error.common.numeric.int.between' | translate:{param1: 0, param2: 100} }}
            </mat-error>
            <mat-error *ngIf="form.controls.resultTolerancePercent.errors?.pattern">
              {{'error.common.numeric.int.positive' | translate}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
  <div class="asi-container" fxLayout="row" fxLayoutAlign="end center">
    <button pButton class="neq-primeng-button-text" label="{{'label.common.edition.cancel' | translate}}" (click)="goBack()"></button>
    <button pButton class="neq-primeng-button-text" label="{{'label.common.edition.confirm' | translate}}" (click)="continue()"></button>
  </div>
</div>
